import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'climb-onboarding-banner',
    templateUrl: './onboarding-banner.component.html',
    styleUrls: ['./onboarding-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingBannerComponent {}
